import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import ROLES from "constants/roles";
import { BlockLink } from "../../components/Animations";
import assets from "../../assets/images/asset.png";
import liabilities from "../../assets/images/debt.png";
import insurance from "../../assets/images/insurance.png";
import income from "../../assets/images/contributions.png";
import assistance from "../../assets/images/savings.png";
import budget from "../../assets/images/calculator.png";
import PageTitle from "components/layout/PageTitle";
import { Row } from "antd";
import moment from "moment";
import ModalVideo from "../../newComponents/ModuleVideos/ModalVideo";

class Modules extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {}
  hasPermission(checkPermissions = []) {
    const availablePermissions =
      localStorage.getItem("permissionState") != "undefined" &&
      JSON.parse(localStorage.getItem("permissionState") || null);
    return checkPermissions.some(
      (p) => availablePermissions && availablePermissions.includes(p)
    );
  }

  render() {
    const block_links = [
      {
        href: "/assets",
        title: "Assets",
        visible: this.props.user.role == ROLES.FREE_APP_SUITE ? false : true,
        img: assets,
        permission: [
          "asset allocation",
          "Create Client's Accounts Assets",
          "Fetch Client's Accounts Assets",
          "Delete Client's Accounts Assets",
          "Super Admin",
        ],
      },
      {
        href: "/liabilities_credit",
        title: "Liabilities and Credit",
        visible: this.props.user.role == ROLES.FREE_APP_SUITE ? false : true,
        img: liabilities,
        permission: [
          "asset allocation",
          "Create Client's Accounts Assets",
          "Fetch Client's Accounts Assets",
          "Delete Client's Accounts Assets",
          "Super Admin",
        ],
      },

      {
        href: "/insurance",
        title: "Insurance",
        visible: this.props.user.role == ROLES.FREE_APP_SUITE ? false : true,
        img: insurance,
        permission: [
          // "asset allocation",
          // "Create Client's Accounts Assets",
          // "Fetch Client's Accounts Assets",
          // "Delete Client's Accounts Assets",
          "Super Admin",
        ],
      },
      {
        href: "/income",
        title: "Sources of Income",
        visible: true,
        img: income,
        permission: [
          // "asset allocation",
          // "Create Client's Accounts Assets",
          // "Fetch Client's Accounts Assets",
          // "Delete Client's Accounts Assets",
          "Super Admin",
        ],
      },
      // {
      //   href: "/assistance/create",
      //   title: "Assistance",
      //   visible: this.props.user.role == ROLES.FREE_APP_SUITE ? false : true,
      //   img: assistance,
      //   permission: [""],
      // },
      {
        // href: '/budget',
        href: "/budget",
        title: "Budget",
        visible: this.props.user.role == ROLES.FREE_APP_SUITE ? false : true,
        img: budget,
        permission: [
          "Super Admin",
          "Calculate Budget",
          "Get Transactions",
          "Create Transaction",
          "Create Category",
          "Create Budget",
        ],
      },
      //            {
      //                href: '/social_security',
      //                title: 'Social Security',
      //                visible: (this.props.user.role == ROLES.FREE_APP_SUITE) ? false : true
      //            }
    ];

    return (
      <React.Fragment>
        {/* <div className='page-title'>
          <div style={{ marginBottom: '5em' }}>
            <PageTitle title='Organizer' />
          </div>
        </div> */}
        <ModalVideo module="Organizer" autoOpen={true} />
        <div className="asset-heading">
          <Row style={{ textAlign: "center" }}>
            <div>
              <h2 style={{ color: "black" }} className=" font-weight">
                ORGANIZER
              </h2>
            </div>
          </Row>
          <Row
            justify="center"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <div>
              <h5 style={{ color: "black" }} className=" font-weight">
                Client Name:
                {localStorage.getItem("User") ? (
                  localStorage.getItem("User")
                ) : (
                  <React.Fragment></React.Fragment>
                )}
              </h5>
            </div>
            <div>
              <h5 style={{ color: "black" }} className=" font-weight">
                Plan: Plan One
              </h5>
            </div>

            <div>
              <h5 style={{ color: "black" }} className=" font-weight">
                Today's Date: {moment().format("MM/DD/YYYY")}
              </h5>
            </div>
          </Row>
        </div>
        {/* <div className='module-blocks2'>

          {block_links.map((blocklink, bindex) => {
            if (blocklink.visible) {
              return (
                <BlockLink
                  key={bindex}
                  img={blocklink.img}
                  className='module-block-link2'
                  link={blocklink.href}
                  title={blocklink.title}
                />
              );
            } else {
              return <React.Fragment></React.Fragment>;
            }
          })}
        </div> */}
        <div className="module-blocks">
          {block_links.map((blocklink, bindex) => {
            return (
              <div key={bindex} className="module-block-link">
                <Link
                  to={{
                    pathname: blocklink.href,
                    state: { title: blocklink.title },
                  }}
                  style={{
                    pointerEvents: this.hasPermission(blocklink.permission)
                      ? ""
                      : "none",
                  }}
                >
                  <div
                    className={"button-wrap-goals"}
                    style={{
                      cursor: this.hasPermission(blocklink.permission)
                        ? ""
                        : "not-allowed",
                      pointerEvents: this.hasPermission(blocklink.permission)
                        ? ""
                        : "none",
                      opacity: this.hasPermission(blocklink.permission)
                        ? "1"
                        : "0.5",
                    }}
                  >
                    <div style={{ flexDirection: "column" }}>
                      <div className="col-12 mt-2 mb-2">
                        <img src={blocklink.img} className="img-btn" />
                      </div>
                      <div className="col-12 mb-2 mt-2">{blocklink.title}</div>
                    </div>
                  </div>
                </Link>
              </div>
            );
            {
              /* if (this.hasPermission(blocklink.permission)) {
              return (
                <BlockLink
                  key={bindex}
                  img={blocklink.img}
                  className="module-block-link"
                  style={{ opacity: "0.5" }}
                  link={blocklink.href}
                  title={blocklink.title}
                />
              );
            } else {
              return <React.Fragment></React.Fragment>;
            } */
            }
          })}
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.rootReducer.loginUser.loginUserData,
  };
};
export default connect(mapStateToProps, null)(Modules);
